import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6zreqkm2qh: FaireBrandEntity = {
  token: "b_6zreqkm2qh",
  type: "brand",
  name: "Efpy Beauty",
  avatarUrl:
    "https://cdn.faire.com/fastly/b092b7aa0752655cccfad89d6884f7b4e8125c1959f29f2c1015dc88b70bafac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2a178ac848293287b1caaac408909e4dfaf28dba5bb8c49be6689033a65941e0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b092b7aa0752655cccfad89d6884f7b4e8125c1959f29f2c1015dc88b70bafac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2a178ac848293287b1caaac408909e4dfaf28dba5bb8c49be6689033a65941e0.png",
  location: "Foster City, CA, USA",
  minimumOrderDollars: 70,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    'World\'s first micro-dose lip balms that upgrade your vibe (not just your lips)!\nCrafted with 1/4th trusted and proven functional actives like green coffee, L-theanine and B vitamins, Efpy lip balms are your pocket sized support. Each swipe delivers a micro-dose of these vitamins and amino acids that build up over time for a calmer, clearer you!\nTopped with aromatherapy from essential oils, these balms are truly one-of-a-kind.\nEfpy (pronounced as "F.P") is a love letter to the Full Potential within each of us.',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:42.317Z",
    importedBy: "entity-db-cli",
  },
};
